
export default {
  name: 'BoardItem',
  components: {},
  props: ['item'],
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {

  },
  methods: {
    selectBoard () {
      this.$store.dispatch('selectBoard', { name: this.item.name, question: this.item.questions, billFetch: this.item.billFetch, partial: this.item.partial, bbps: this.item.bbps })
      this.$router.push({ name: 'FetchBill', params: { category: this.$route.params.category }, query: this.$route.query })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BoardItem/component.js